import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStop$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStop extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '835857cc389d8e90b21d1dad914005dc5fcf8d8a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1bc2d13c45880825e01fb98b0aa16ee342d669c9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd40169e4449baa14e9123a222f2a43fe539ca128', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 6h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-stop", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-stop"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-stop":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStop$1);
            }
            break;
    } });
}

const CosmosIconStop = CosmosIconStop$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStop, defineCustomElement };
